module.exports = __webpack_public_path__ + "static/media/Group-2806-silver.87d4a9b0.svg";